import { useMutation, useQueryClient } from '@tanstack/react-query'
import { hapticSuccess, hapticError } from '@/telegram'
import { toast } from 'sonner'
import { useClobClient } from './useClobClient'

export function useCancelOrder() {
  const queryClient = useQueryClient()
  const clobClient = useClobClient()

  return useMutation({
    mutationFn: async (tokenId: string) => {
      if (!clobClient) throw new Error('Connect a wallet')
      return clobClient.cancelMarketOrders({ asset_id: tokenId })
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['openOrders'] })
      void queryClient.invalidateQueries({ queryKey: ['positions'] })
      hapticSuccess()
      toast.success('Order cancelled')
    },
    onError: (err) => {
      hapticError()
      toast.error(err instanceof Error ? err.message : 'Error cancelling order')
    },
  })
}
